import { useAuthState } from "@/contexts/auth/auth.provider";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_HARAJ_RIZE_RNPL_REQUEST } from "@/graphql/mutations/listing";
import { RNPL_PROVIDERS } from "@/common/constants";
import css from "@/src/pages/haraj/rnpl/[haraj_listing_id]/index.module.scss";
import { Button, Checkbox, Modal } from "@aqar-app/react-ui";
import { trackRNPLProviderConfirm } from "@/lib/tracking/trackRNPLEvents";
import { usePath } from "@/contexts/path/path";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import { sharedHarajRNPLTracker } from "@/lib/tracking/trackHarajRNPLEvents";

export const HarajRizeForm = ({ adLicenseNumber }) => {
  const { token } = useAuthState();
  const router = useRouter();
  const { previousPath } = usePath();
  const [values, setValues] = useState({ accepted: false });

  const [createRizeRequest, { loading }] = useMutation(
    CREATE_HARAJ_RIZE_RNPL_REQUEST,
    {
      context: { token },
      variables: { ad_license_number: adLicenseNumber.toString() },
      onCompleted: (data) => {
        const { id, rize_link, request_id, request_date } =
          data?.RentNowPayLater?.createRizeRnplRequest || {};
        router.push(
          `haraj/rnpl/summary/${id}?provider=${RNPL_PROVIDERS.rize.name}&request_id=${request_id}&rize_link=${rize_link}&request_date=${request_date}&listing_id=${listingId}`,
        );
      },
      onError: (error) => {
        Modal.open(
          <ClassicModal
            ok={{
              label: "حسنا",
              cb: (e) => Modal.close(e),
            }}
            body={<p>{error.message || "الرجاء المحاولة لاحقاً."}</p>}
          />,
        )();
      },
    },
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    sharedHarajRNPLTracker({
      target: "rize_confirm",
      source: previousPath || decodeURI(document.referrer),
    });
    createRizeRequest();
  };

  return (
    <div className={css.providerForm}>
      <Checkbox
        checked={values.accepted}
        onChange={(e) => setValues({ ...values, accepted: e.target.checked })}
        size="small"
      >
        <p className={css.terms}>
          أوافق على شروط الخدمة وأقر بحصولي على موافقة المعلن على تأجير الوحدة
          بالباطن. وأوافق على{" "}
          <a href={RNPL_PROVIDERS.rize.ar_tc} target="_blank">
            الشروط والأحكام
          </a>{" "}
          و
          <a href={RNPL_PROVIDERS.rize.ar_pp} target="_blank">
            سياسة الخصوصية
          </a>{" "}
          الخاصة بمزود الخدمة.
        </p>
      </Checkbox>
      <div className={css.submitBtn}>
        <Button
          theme="primary"
          outline
          disabled={!values.accepted || loading}
          onClick={handleSubmit}
        >
          إرسال
        </Button>
      </div>
    </div>
  );
};
